const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_WEB_URL: process.env.REACT_APP_WEB_BASE_URL,
  AZURE_CLIENT_ID : process.env.REACT_APP_AZURE_CLIENT_ID,
  AZURE_GROUP_ID : process.env.REACT_APP_AZURE_GROUP_ID,
  AZURE_BASIC_ID : process.env.REACT_APP_AZURE_BASIC_USER_GROUP_ID ,
  AZURE_TENANT_ID : process.env.REACT_APP_AZURE_TENANT_ID,
  KIT_IMG_URL: process.env.REACT_APP_KIT_IMG_URL,
  CONVERGE_LIGHTBOX_URL: process.env.REACT_APP_CONVERGE_LIGHTBOX_URL,
  PAYMENT_GATEWAY: process.env.REACT_APP_PAYMENT_GATEWAY
};

export default config;